import React from "react";
import { useParams } from "react-router-dom";
import { PhoneOutlined, HomeOutlined } from "@ant-design/icons";
import useFetch from "../../hooks/useFetch";
import ReactPlayer from "react-player";
import { Breadcrumb } from 'antd';
import { NavLink } from "react-router-dom";
import './index.css'

const BusinessCard = () => {
  return (
    <div className="w-72 flex flex-col bg-cyan-300 rounded-md py-4 px-4 text-sm gap-y-2">
      <h4 className="text-lg font-bold">联系我们</h4>
      <span>
        上海墨圆方信息科技有限公司
      </span>
      <span className="flex space-x-2 justify-start">
        <span><HomeOutlined /></span>
        <span>上海, 宝山区, 环上大科技园零号基地, 上大路668号418室</span>
      </span>
      <span className="flex space-x-2">
        <span className="flex items-center"><PhoneOutlined /></span>
        <span>19821211541</span>
      </span>
    </div>
  )
}

const SolutionContent = () => {
  let { solutionContentId, solutionId } = useParams();

  const content = useFetch(`http://1.94.62.64:9090/myf/getApplicationCases/detail/${solutionContentId}`)

  const breadCrumbList = [
    {
      title: <NavLink to='/' className='mt-0 flex'>
        <span className='text-sm text-blue-600'>
          主页
        </span>
      </NavLink>

    },
    {
      title: <NavLink to='/solution'>
        <span className='text-sm text-blue-600'>
          解决方案
        </span>
      </NavLink>
    },
    {
      title: <NavLink
        to={`/solution/${solutionId}`}

      >
        <span className='text-sm text-blue-600'>
          {`解决方案 ${solutionId}`}
        </span>
      </NavLink>
    },
    {
      title: <NavLink
        to={`/solution/${solutionId}/${solutionContentId}`}
      >
        <span className='text-sm'>
          {`案例 ${solutionContentId}`}
        </span>
      </NavLink>
    }
  ]

  return (
    <div>
      <div className="flex flex-col items-center mt-[260px]">
        <div className="mb-4">
          <div>
            <Breadcrumb
              items={breadCrumbList}
            />
          </div>
        </div>
        <div className="flex flex-col px-16 py-4 bg-slate-200 relative  mb-[100px] w-2/3 rounded-md">
          <div className="flex w-2/3 min-h-screen">
            {content && content.map((content) => {
              return (
                <div className="text-xl my-4" key={content.id}>
                  <h3 className="text-3xl">{content.fatherTitle}</h3>
                  {content.alist.map((item) => {
                    const { id, title, picture, video } = item
                    return (
                      <div className="text-md px-2" key={id}>
                        <h4 className="font-bold">{title}</h4>
                        <p>{item.content}</p>
                        <img
                          className="w-72"
                          src={picture}
                          alt="img"
                        />
                        {
                          video && (
                            <ReactPlayer
                              controls
                              width={600}
                              height={400}
                              url={video}
                            />
                          )
                        }
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
          <div className="absolute right-10 top-3 my-4">
            <BusinessCard />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionContent;
